import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Grid, Typography } from '@mui/material';
import Wifi from 'assets/images/Wifi.svg';
import Snack from 'assets/images/Snack.svg';
import Charger from 'assets/images/Charger.svg';
import NewsPaper from 'assets/images/NewsPaper.svg';
import WaterBottle from 'assets/images/WaterBottle.svg';

function CabFacilities() {
  const cabFacility = useSelector(
    (state) =>
      state?.userCarFacilities?.userCarFacilities?.data?.body?.[0]?.Facilities
  );

  // ---For Image Error---
  const handleOnError = (e, facilityName) => {
    let replacementImage;
    switch (facilityName) {
      case 'Wifi':
        replacementImage = Wifi;
        break;
      case 'Snack':
        replacementImage = Snack;
        break;
      case 'Charger':
        replacementImage = Charger;
        break;
      case 'News Paper':
        replacementImage = NewsPaper;
        break;
      case 'Water Bottel':
        replacementImage = WaterBottle;
        break;
      default:
        replacementImage = Wifi;
    }
    e.target.src = replacementImage;
  };
  return (
    <div className="borderTop">
      <Typography
        variant="head5"
        component={'h2'}
        className="colorBlack fw600 mb20 marginTop"
      >
        Facilities
      </Typography>
      <Grid container className="mt30 mb20">
        {cabFacility?.length ? (
          cabFacility?.map((row, index) => (
            <Grid
              item
              md={2.4}
              sm={6}
              xs={12}
              key={index}
              className="facilityDashBoarder"
            >
              <Box className="justifyCenter ptb20">
                <Box className="flex" alignItems={'center'}>
                  <img
                    src={row?.img?.url}
                    alt="Logo"
                    className="width40 height40 objectFit"
                    onError={(e) => handleOnError(e, row?.name)}
                  />
                </Box>
                <Typography variant="body2" className="colorGrey pl20">
                  {row?.name || 'NA'}
                </Typography>
              </Box>
            </Grid>
          ))
        ) : (
          <Typography variant="body2" className="colorGrey pl20">
            No Facilites Available
          </Typography>
        )}
      </Grid>
    </div>
  );
}

export default CabFacilities;
